import { Star, MapPin, Users, BedDouble, Bath, Gamepad2, Caravan } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLang } from "@/context/LanguageContext";

export const Hero = ({ property }) => {
  const { t } = useLang();
  const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  const img = property?.hero_image || property?.images?.[0]?.url;

  return (
    <section className="relative min-h-screen flex items-end md:items-center overflow-hidden">
      <img src={img} alt={property?.name} className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 hero-overlay" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pb-16 md:pb-0 pt-28">
        <div className="max-w-2xl animate-fade-up">
          <div className="flex items-center gap-2 text-white/90 mb-4">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-4 w-4 fill-amber-400 text-amber-400" />
              ))}
            </div>
            <span className="text-sm font-medium">{t("Loved by families · Direct booking")}</span>
          </div>

          <h1
            className="font-script text-6xl sm:text-7xl lg:text-8xl text-white leading-[1.1] text-balance"
            style={{ WebkitTextStroke: "2.2px #ffffff", textShadow: "0 4px 16px rgba(0,0,0,0.6), 0 1px 3px rgba(0,0,0,0.5)" }}
          >
            {property?.name}
          </h1>
          <p className="mt-4 text-lg md:text-xl text-white/90 max-w-xl">{t(property?.tagline)}</p>

          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 mt-6 text-white/90 text-sm">
            <span className="flex items-center gap-1.5"><MapPin className="h-4 w-4" strokeWidth={1.5} /> {property?.location}</span>
            <span className="flex items-center gap-1.5"><Users className="h-4 w-4" strokeWidth={1.5} /> {property?.max_guests} {t("guests")}</span>
            <span className="flex items-center gap-1.5"><BedDouble className="h-4 w-4" strokeWidth={1.5} /> {property?.bedrooms} {t("bedrooms")}</span>
            <span className="flex items-center gap-1.5"><Bath className="h-4 w-4" strokeWidth={1.5} /> {property?.bathrooms} {t("baths")}</span>
            <span className="flex items-center gap-1.5"><Gamepad2 className="h-4 w-4" strokeWidth={1.5} /> {t("Separate game room")}</span>
            <span className="flex items-center gap-1.5"><Caravan className="h-4 w-4" strokeWidth={1.5} /> {t("RV/Toy Trailer parking")}</span>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 mt-8">
            <Button
              data-testid="hero-check-availability-btn"
              onClick={() => scrollTo("#book")}
              size="lg"
              className="rounded-full bg-primary hover:bg-primary/90 hover:-translate-y-0.5 transition-all shadow-lg text-base px-8 h-12"
            >
              {t("Check Availability")}
            </Button>
            <Button
              data-testid="hero-ask-btn"
              onClick={() => scrollTo("#contact")}
              size="lg"
              variant="outline"
              className="rounded-full bg-white/10 backdrop-blur border-white/40 text-white hover:bg-white/20 hover:text-white text-base px-8 h-12"
            >
              {t("Ask a Question")}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
